<template lang="pug">
.section-header
    div.section-header-wrapper.l-flex-row--between.l-align-center
        template
            slot(name='icon')
        h1.section-header--title.flex-1(v-if='title === "Audiences & Transfers"')
            | audiences&nbsp;
            span.highlight &
            |
            | transfers
        h1.section-header--title.flex-1(v-else)
            slot(name="title")
                span {{ title }}
            .section-header--counter(v-if='counter && counter !== 0  && counterLimit') {{ counter + ' / ' + counterLimit }}
            .section-header--counter(v-else-if='counter && counter !== 0') {{ counter }}
            template
                slot(name='actionLeft')

        template
            slot(name='action')

    template
        slot(name='subHeader')
</template>

<script>
export default {
    name: 'SectionHeader',
    props: {
        title: {
            type: String,
            required: true
        },
        action: {
            type: Boolean,
            default: false
        },
        actionLeft: {
            type: Boolean,
            default: false
        },
        counter: {
            type: Number,
            required: false,
            default: null
        },
        counterLimit: {
            type: Number,
            required: false,
            default: null
        }
    }
}
</script>
